import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined
} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import PageRoutes from "./PageRoutes"
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
const { Header, Sider, Content } = Layout;

const AppMenu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const menuClick = (e) => {

    navigate(e.key);
  }

  return (

          <Menu
            theme="dark"
            mode="inline"
            onClick={menuClick}
            defaultSelectedKeys={['']}
            items={[
              {
                key: '/products',
                icon: <ProductOutlined />,
                label: 'Sản phẩm',
                path: "acb"
              },
              {
                key: '/orders',
                icon: <FileTextOutlined />,
                label: 'Đơn hàng',
              },
              // {
              //   key: '/payment-confirm',
              //   icon: <FileTextOutlined />,
              //   label: 'Thanh toán',
              // },
              {
                key: '/customers',
                icon: <HeartOutlined />,
                label: 'Khách hàng',
              },

              {
                key: '/debt',
                icon: <AuditOutlined />,
                label: 'Công nợ',
              },
              {
                key: '/vouchers',
                icon: <GiftOutlined />,
                label: 'Mã giảm giá',
              },

              {
                key: '/setting',
                icon: <SettingOutlined />,
                label: 'Cài đặt',
                children: [
                  {
                    key: '/product_option',
                    icon: <GatewayOutlined />,
                    label: 'Biến thể',
                  },
                  {
                    key: '/product_tag',
                    icon: <TagOutlined />,
                    label: 'Thẻ',
                  },
                  {
                    key: '/product_category',
                    icon: <GroupOutlined />,
                    label: 'Phân loại',
                  },
                ]

              },



            ]}
          />
      
  );
};

export default AppMenu;